var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedirectionArrowRightOpacityBlueBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.2927 1H12.7073C6.24154 1 1 6.24154 1 12.7073V37.2927C1 43.7585 6.24154 49 12.7073 49H37.2927C43.7585 49 49 43.7585 49 37.2927V12.7073C49 6.24154 43.7585 1 37.2927 1Z",
    fill: "#102C5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 36.522L20.1054 39L32 25.0001L20.1053 11L18 13.478L27.7892 24.9995L18 36.522Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectionArrowRightOpacityBlueBox);
export default __webpack_public_path__ + "static/media/redirection_arrow_right_opacity_blue_box.75ff0743fd5c4211bd0af34361a39d75.svg";
export { ForwardRef as ReactComponent };